import RaiseComplaints from "../../../jsx/components/Dashboard/RaiseComplaints/raisecomplaints";

const RaiseComplaintsWrapper = () => {
  return <RaiseComplaints />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.data_entry];
export default constore(RaiseComplaintsWrapper);
